// import { useState } from "react";
// import axios from "axios";

// function useHttp() {
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [downloadProgress, setDownloadProgress] = useState(0);

//   const sendRequests = (requestConfig, applyData) => {
//     setIsLoading(true);
//     setError(null);

//     const headers = requestConfig.headers ? requestConfig.headers : {};
//     const access_token = JSON.parse(localStorage.getItem("auth_token"))?.access;

//     if (requestConfig.url.isAuthorizationRequired && access_token && !headers.authorization)  {
//       headers["authorization"] = `Bearer ${access_token}`;
//     }

//     axios({
//       url: requestConfig?.url?.url,
//       method: requestConfig.method ? requestConfig.method : "GET",
//       headers: {
//         ...headers,
//       },
//       onDownloadProgress(progressEvent) {
//         var percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
//         setDownloadProgress(percent);
//       },
//       data: JSON.stringify(requestConfig.data) ? requestConfig.data : null,
//       params: requestConfig.params ? requestConfig.params : {},
//     })
//       .then((res) => res.data)
//       .then((data) => {
//         applyData(data);
//         setIsLoading(false);
//         setDownloadProgress(0);
//       })
//       .catch((err) => {
//         if (err && err.response && err.response.status === 500) {
//           setError({
//             general: ['Something went wrong. Please try again later.'],
//           });
//         } else if (err && err.response && err.response.data) {
//           setError(err.response.data);
//         } else {
//           setError({
//             general: ['Something went wrong. Please try again later.'],
//           });
//         }
//         setIsLoading(false);
//         setDownloadProgress(0);
//       });
//   };

//   return {
//     isLoading,
//     error,
//     sendRequests,
//     downloadProgress,
//   };
// }

// export default useHttp;

import { useState, useCallback } from "react";
import axios from "axios";

function useHttp() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [downloadProgress, setDownloadProgress] = useState(0);

  const sendRequests = useCallback((requestConfig, applyData) => {
    setIsLoading(true);
    setError(null);

    const headers = requestConfig.headers ? requestConfig.headers : {};
    const access_token = JSON.parse(localStorage.getItem("auth_token"))?.access;

    if (requestConfig.url.isAuthorizationRequired && access_token && !headers.authorization)  {
      headers["authorization"] = `Bearer ${access_token}`;
    }

    axios({
      url: requestConfig?.url?.url,
      method: requestConfig.method ? requestConfig.method : "GET",
      headers: {
        ...headers,
      },
      onDownloadProgress(progressEvent) {
        var percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
        setDownloadProgress(percent);
      },
      data: JSON.stringify(requestConfig.data) ? requestConfig.data : null,
      params: requestConfig.params ? requestConfig.params : {},
    })
      .then((res) => res.data)
      .then((data) => {
        applyData(data);
        setIsLoading(false);
        setDownloadProgress(0);
      })
      .catch((err) => {
        if (err && err.response && err.response.status === 500) {
          setError({
            general: ['Something went wrong. Please try again later.'],
          });
        } else if (err && err.response && err.response.data) {
          setError(err.response.data);
        } else {
          setError({
            general: ['Something went wrong. Please try again later.'],
          });
        }
        setIsLoading(false);
        setDownloadProgress(0);
      });
  }, []); // Memoizing `sendRequests` to prevent re-renders

  return {
    isLoading,
    error,
    sendRequests,
    downloadProgress,
  };
}

export default useHttp;
